export const CUSTOM_ADD_GIFTBOX_TO_CART_PROCESS_ID = 'addGiftboxToCart';
